import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { AuditService } from '@core/services/audit.service';
import { registerGlobalJsErrors } from '@core/errors/global-js-errors';
import { environment } from './environments/environment';

const LS_USER = 'userName';
const LS_COMPANY = 'companyId';
const LS_PROVEEDOR_ID = 'proveedorId';

type DevSeed = { userName: string; companyId: number; proveedorId?: number };

/** Solo desarrollo: crea `userName`, `companyId` y `proveedorId` en localStorage si faltan (ver `environment.devSeedLocalStorage`). */
function seedDevLocalStorageFromEnvironment(): void {
  if (environment.production) return;
  const seed = (environment as { devSeedLocalStorage?: DevSeed })
    .devSeedLocalStorage;
  if (!seed?.userName || seed.companyId == null) return;
  if (!localStorage.getItem(LS_USER)) {
    localStorage.setItem(LS_USER, seed.userName);
  }
  if (!localStorage.getItem(LS_COMPANY)) {
    localStorage.setItem(LS_COMPANY, String(seed.companyId));
  }
  if (seed.proveedorId != null) {
    const existing = localStorage.getItem(LS_PROVEEDOR_ID);
    if (!existing || existing === '0') {
      localStorage.setItem(LS_PROVEEDOR_ID, String(seed.proveedorId));
    }
  }
}

seedDevLocalStorageFromEnvironment();

bootstrapApplication(AppComponent, appConfig)
  .then((appRef) => {
    const audit = appRef.injector.get(AuditService);
    registerGlobalJsErrors(audit);
  })
  .catch(() => {
    // fallback extremo
  });
